import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Globe, Smartphone, Layout, Cloud, Code2, Link2 } from 'lucide-react';

export const Services = () => {
  const { t } = useLanguage();

  const services = [
    { key: 'webApps', icon: Globe, color: 'text-blue-400', bgColor: 'bg-blue-500/10' },
    { key: 'mobileApps', icon: Smartphone, color: 'text-orange-400', bgColor: 'bg-orange-500/10' },
    { key: 'websites', icon: Layout, color: 'text-green-400', bgColor: 'bg-green-500/10' },
    { key: 'saas', icon: Cloud, color: 'text-purple-400', bgColor: 'bg-purple-500/10' },
    { key: 'custom', icon: Code2, color: 'text-cyan-400', bgColor: 'bg-cyan-500/10' },
    { key: 'integrations', icon: Link2, color: 'text-pink-400', bgColor: 'bg-pink-500/10' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section id="services" className="py-20 lg:py-32 px-4 bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="section-title">{t('services.title')}</h2>
          <p className="section-subtitle">{t('services.subtitle')}</p>
        </motion.div>

        {/* Services Grid - Bento style */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {services.map((service, index) => {
            const Icon = service.icon;
            const serviceData = t(`services.items.${service.key}`);
            
            return (
              <motion.div
                key={service.key}
                variants={itemVariants}
                className={`service-card card-hover ${index === 0 ? 'lg:col-span-2' : ''}`}
                data-testid={`service-card-${service.key}`}
              >
                <div className={`inline-flex p-3 rounded-xl ${service.bgColor} mb-4`}>
                  <Icon className={`w-6 h-6 ${service.color}`} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {serviceData.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {serviceData.desc}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
